import React, { useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import Layout from "src/features/Layout"
import Typography from "@material-ui/core/Typography"
import Button from "@material-ui/core/Button"
import Box from "@material-ui/core/Box"
import get from "lodash/get"
import useNotification from "src/features/Notification/customs"
import { Form } from "react-final-form"
import { editBundle, fetchDetail } from "../Create/ducks"
import { removeById } from "../List/ducks"

import Step2 from "../Create/Step2"

function Index() {
  const dispatch = useDispatch()
  const { showError, showSuccess } = useNotification()

  const detail = useSelector((state) => state.bundle_create.detail)
  const _id = useSelector((state) => state.router.location.pathname).split(
    "/"
  )[2]

  useEffect(() => {
    dispatch(fetchDetail(_id))
    return () => {}
  }, [dispatch, _id])

  const calculatedTotalMedicinePrice = get(detail, "medicine", []).length
    ? get(detail, "medicine", [])
        .map((item) =>
          item.is_promo
            ? item.promo_price * item.amount
            : item.price * item.amount
        )
        .reduce((acc, crv) => acc + crv)
    : 0
  const calculatedTotalSupplyPrice = get(detail, "supply", []).length
    ? get(detail, "supply", [])
        .map((item) =>
          item.is_promo
            ? item.promo_price * item.amount
            : item.price * item.amount
        )
        .reduce((acc, crv) => acc + crv)
    : 0

  const total_price = calculatedTotalMedicinePrice + calculatedTotalSupplyPrice

  const handleDelete = async () => {
    await dispatch(removeById(_id))
    await dispatch(fetchDetail(_id))
  }

  return (
    <Form
      initialValues={{
        name: get(detail, "name"),
        promo_price: get(detail, "promo_price"),
        detail: get(detail, "detail"),
        active: get(detail, "active"),
        supply: get(detail, "supply", []),
        medicine: get(detail, "medicine", []),
        cover_img: get(detail, "cover_img"),
      }}
      onSubmit={async ({ cover_img, ...restvalues }) => {
        try {
          if (restvalues.promo_price >= total_price) {
            showError("Bundle price must not be lower than total price.")
          } else {
            let newValues = { ...restvalues }

            if (cover_img !== get(detail, "cover_img")) {
              newValues.cover_img = cover_img
            }

            await dispatch(
              editBundle(_id, {
                ...newValues,
                promo_price: parseInt(newValues.promo_price),
                medicine: newValues.medicine.map((item) => ({
                  _id: item._id,
                  amount: item.amount,
                })),
              })
            )
            await dispatch(fetchDetail(_id))
            showSuccess()
          }
        } catch (error) {
          showError()
        }
      }}
      mutators={{
        setImg: (args, state, utils) => {
          utils.changeValue(state, "cover_img", () => args[0])
        },
      }}
      subscription={{ values: true, submitting: true }}
    >
      {({ handleSubmit }) => (
        <Layout
          breadcrumbs={{
            previous: [{ href: "/bundle", name: "List" }],
            current: "Edit",
          }}
        >
          <Typography variant="h5" gutterBottom>
            Edit Bundle
          </Typography>
          <Box textAlign="right" mt={-6}>
            <Button
              variant="contained"
              size="large"
              disableElevation
              color="secondary"
              onClick={handleSubmit}
            >
              Edit Bundle
            </Button>
          </Box>
          <Step2 totalPrice={total_price} />
          <Box textAlign="center" mt={2} mb={5}>
            <Button
              variant="contained"
              disabled={!!detail.end_date}
              onClick={handleDelete}
            >
              {!!detail.end_date
                ? "This bundle will be delete after 12.00 pm"
                : "Delete Bundle"}
            </Button>
          </Box>
        </Layout>
      )}
    </Form>
  )
}

export default Index
